import { IconPropsType } from '..';

export const EnFlag = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_25137_11974"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <circle
          cx="9"
          cy="9"
          r="9"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask0_25137_11974)">
        <path
          d="M24.1945 -1.23975H-6.52734V19.2415H24.1945V-1.23975Z"
          fill="#002173"
        />
        <path
          d="M-8.80078 -1.5332L27.8383 17.5019L26.5159 20.2497L-10.1232 1.21465L-8.80078 -1.5332Z"
          fill="white"
        />
        <path
          d="M-9.94285 0.757391L-9.48545 -0.194624L8.14371 8.96485L7.68517 9.91629L-9.94285 0.757391Z"
          fill="#C61018"
        />
        <path
          d="M8.83449 9.00104L9.29189 8.04903L26.9211 17.2085L26.4625 18.1599L8.83449 9.00104Z"
          fill="#C61018"
        />
        <path
          d="M-10.1725 16.7853L26.4666 -2.24985L27.789 0.498002L-8.84958 19.5343L-10.1725 16.7853Z"
          fill="white"
        />
        <path
          d="M-9.48515 18.1614L8.83327 8.64296L9.27407 9.55891L-9.04435 19.0773L-9.48515 18.1614Z"
          fill="#C61018"
        />
        <path
          d="M8.37618 8.08569L26.6946 -1.43273L27.1354 -0.516778L8.81698 9.00163L8.37618 8.08569Z"
          fill="#C61018"
        />
        <path
          d="M26.7543 6.44072H11.3934V-1.23975H6.27304V6.44072H-9.08789V11.561H6.27304V19.2415H11.3934V11.561H26.7543V6.44072Z"
          fill="white"
        />
        <path
          d="M26.7543 7.46479H10.3693V-1.23975H7.29711V7.46479H-9.08789V10.537H7.29711V19.2415H10.3693V10.537H26.7543V7.46479Z"
          fill="#C61018"
        />
      </g>
    </svg>
  );
};
